// PONTE ISOLADA — distribui as questões das provas oficiais (src/data/bancas/*)
// nas 9 categorias da tela "Categorias" (SelectCategoryScreen).
//
// Princípio: as bancas continuam READ-ONLY / embarcadas. Aqui só derivamos o
// campo `category` a partir da `disciplina` e cacheamos em memória. NADA é
// gravado no AsyncStorage (acervo `QUESTIONS`). Por isso estas questões NÃO
// aparecem em ManageQuestions, Simulado, Repetição Espaçada, Home, etc. — só
// nas duas telas que importam este módulo (Categorias + seu "Praticar").

import { getQuestionsByBanca } from './index';

// De-para: disciplina (provas BB) -> categoria (CATEGORIES em src/constants/categories.js).
// Disciplinas afins caem na categoria mais próxima (decisão do projeto):
// - Vendas e Negociação / Técnicas de Vendas / Cultura Organizacional -> Atendimento
// - Raciocínio Lógico-Matemático -> Matemática
// - Atualidades do Mercado Financeiro -> Atualidades
export const DISCIPLINA_TO_CATEGORIA = {
  'Português': 'PORTUGUES',
  'Conhecimentos Bancários': 'CONHECIMENTOS_BANCARIOS',
  'Informática': 'INFORMATICA',
  'Conhecimentos Gerais de Informática': 'INFORMATICA',
  'Matemática': 'MATEMATICA',
  'Raciocínio Lógico': 'MATEMATICA',
  'Raciocínio Lógico-Matemático': 'MATEMATICA',
  'Probabilidade e Estatística': 'MATEMATICA',
  'Matemática Financeira': 'MATEMATICA_FINANCEIRA',
  'Inglês': 'INGLES',
  'Atendimento': 'ATENDIMENTO',
  'Vendas e Negociação': 'ATENDIMENTO',
  'Técnicas de Vendas': 'ATENDIMENTO',
  'Cultura Organizacional': 'ATENDIMENTO',
  'Atualidades': 'ATUALIDADES',
  'Atualidades do Mercado Financeiro': 'ATUALIDADES',
};

// Fallback para qualquer disciplina nova não mapeada acima.
const mapDisciplinaToCategoria = (disciplina) =>
  DISCIPLINA_TO_CATEGORIA[disciplina] || 'GERAL';

// Caches em memória (as bancas não mudam em runtime).
let cachedQuestions = null;
let cachedCounts = null;

// Carrega TODAS as questões das provas, já com `category` derivado da disciplina.
export const getBancasCategoryQuestions = async () => {
  if (cachedQuestions) return cachedQuestions;
  const all = await getQuestionsByBanca('all');
  cachedQuestions = all.map((q) => ({
    ...q,
    category: mapDisciplinaToCategoria(q.disciplina),
  }));
  return cachedQuestions;
};

// Contagem por categoria: { CATEGORIA_ID: n }. Usado pelos cards da tela Categorias.
export const getBancasCategoryCounts = async () => {
  if (cachedCounts) return cachedCounts;
  const questions = await getBancasCategoryQuestions();
  const counts = {};
  questions.forEach((q) => {
    counts[q.category] = (counts[q.category] || 0) + 1;
  });
  cachedCounts = counts;
  return counts;
};

// Filtra as questões das bancas pelas categorias selecionadas (para o "Praticar").
export const getBancasQuestionsByCategories = async (categories) => {
  const questions = await getBancasCategoryQuestions();
  if (!categories || categories.length === 0) return questions;
  return questions.filter((q) => categories.includes(q.category));
};
